<template>
  <div class="text-xs flex flex-row w-full justify-between items-center">
    <div>+ {{ addOnDescription }}</div>
    <div class="mr-16 text-gray-500 text-xs whitespace-nowrap">
      <div
        :class="[
          narrow ? 'flex-col items-end' : 'flex-row items-center space-x-2',
          'flex',
        ]"
      >
        <ServerAddOnPriceDisplay :add-on-id="addOnId" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { cleanAddOnName } from "~/helpers/vpsAddOnHelpers";
import { useVpsAddOnCatalogStore } from "../../stores/catalog/vps-addon-catalog";

const props = withDefaults(
  defineProps<{
    narrow?: boolean;
    cartItemId: string;
    addOnId: number;
  }>(),
  {
    narrow: false,
  }
);

const vpsAddOnCatalog = useVpsAddOnCatalogStore();

const addOnDescription = computed(() => {
  const addon = vpsAddOnCatalog.getSubscriptionByAddOnId(props.addOnId);

  return cleanAddOnName(addon?.name) ?? "<ukjent addon>";
});
</script>

<style></style>
